import { render, staticRenderFns } from "./SampleMovies.vue?vue&type=template&id=63683699&scoped=true&"
import script from "./SampleMovies.vue?vue&type=script&lang=js&"
export * from "./SampleMovies.vue?vue&type=script&lang=js&"
import style0 from "./SampleMovies.vue?vue&type=style&index=0&id=63683699&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63683699",
  null
  
)

export default component.exports